import SocketService from '../../../../packages/shared/socket';

export function connectScreenSocket(instanceId, clientType, identifier) {
  return SocketService.connect(instanceId, clientType, identifier);
}
